import React, { useEffect, useState } from 'react'
import { If, Then } from 'react-if'
import { Collapse, IconButton } from '@mui/material'
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon
} from '@mui/icons-material'

import {
  TableCellStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { Item } from 'services/NGT/EffectiveConsolidation'
import { FORMAT, COLORS } from 'utils'

interface ICollapsibleTable {
  row: Item
  isGeneratePDF: boolean
}

export const CollapsibleTable: React.FC<ICollapsibleTable> = ({ row, isGeneratePDF }) => {
  const [open, setOpen] = useState(isGeneratePDF)

  useEffect(() => {
    if (isGeneratePDF) setOpen(true)
  }, [isGeneratePDF])

  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row?.unidadeGestoraInfo.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
        <TableCellStyled minwidth="200px">
          {row?.nmGrupoConsolidacao}
        </TableCellStyled>
        <TableCellStyled align="center">
          {FORMAT.currency(row?.informaoAnoMeses[12]?.info.vlPagamento)}
        </TableCellStyled>

        {row?.informaoAnoMeses.map(({ info, mes }, index) => (
          <If condition={index !== 12} key={mes}>
            <TableCellStyled align="center">
              {FORMAT.currency(info.vlPagamento)}
            </TableCellStyled>
          </If>
        ))}

        <TableCellStyled align="center">
          {row?.variacao}
        </TableCellStyled>
      </TableRowStyled>

      {/*  INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && 'none' }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={20}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled>

              <TableRowStyled
                backgroundColor={COLORS.tableColor}
              >
                <TableCellStyled colSpan={1} />
                <TableCellStyled align="center">Dez</TableCellStyled>
                <TableCellStyled align="center">Jan</TableCellStyled>
                <TableCellStyled align="center">Fev</TableCellStyled>
                <TableCellStyled align="center">Mar</TableCellStyled>
                <TableCellStyled align="center">Abr</TableCellStyled>
                <TableCellStyled align="center">Mai</TableCellStyled>
                <TableCellStyled align="center">Jun</TableCellStyled>
                <TableCellStyled align="center">Jul</TableCellStyled>
                <TableCellStyled align="center">Ago</TableCellStyled>
                <TableCellStyled align="center">Set</TableCellStyled>
                <TableCellStyled align="center">Out</TableCellStyled>
                <TableCellStyled align="center">Nov</TableCellStyled>
                <TableCellStyled align="center">Dez</TableCellStyled>
              </TableRowStyled>

              {row?.unidadeGestoraInfo.map((collapseRow, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled minwidth="200px">
                    {collapseRow?.nmUnidadeGestora}
                  </TableCellStyled>
                  <TableCellStyled
                    align="center"
                  >
                    {FORMAT.currency(collapseRow?.informaoAnoMeses[12]?.info?.vlPagamento)}
                  </TableCellStyled>

                  {collapseRow?.informaoAnoMeses.map(({ info, mes }, index) => (
                    <If condition={index !== 12} key={mes}>
                      <Then>
                        <TableCellStyled
                          align="center"
                        >
                          {FORMAT.currency(info.vlPagamento)}
                        </TableCellStyled>
                      </Then>
                    </If>
                  ))}

                </TableRowStyled>
              ))}
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>
    </>
  )
}
